module.exports = __webpack_public_path__ + "static/media/Digipartnership.805176f0.png";